import React from "react";
import Wave from "react-wavify";

const ClosingAnimatedLayer = () => {
  return (
    <div
      className={`z-[1000] gridAreaOne opacity-100 layerClosing h-[99vh] flex flex-col items-center justify-end`}
    >
      <Wave
        className="relative top-2"
        fill="#000"
        paused={false}
        options={{
          height: 0,
          amplitude: 30,
          speed: 0.3,
          points: 10,
        }}
      />
      <div className="greenWaveClosing h-[100%] w-full">
        <div className="bg-[#000] w-full h-full flex flex-col items-center justify-center"></div>
      </div>
    </div>
  );
};

export default ClosingAnimatedLayer;
